import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface User { [key: string]: any }
interface Credentials { [key: string]: any }

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.stag.kimaru.ai/api/v1/users/',
    credentials: 'include',
  }),

  endpoints: (builder) => ({
    registerUser: builder.mutation<any, User>({
      query: (user: User) => ({
        url: 'register/',
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: user,
      }),
    }),

    loginUser: builder.mutation<any, Credentials>({
      query: (credentials: Credentials) => ({
        url: 'login/',
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: credentials,
      })
    }),

    logoutUser: builder.mutation<any, void>({
      query: () => ({
        url: 'logout/',
        method: 'POST',
      })
    }),
  })
})

export const { useRegisterUserMutation, useLoginUserMutation, useLogoutUserMutation } = authApi;
